import React, { Component } from 'react';
import loadImg from '../img/loader.gif'
class Startbtn extends Component {

  render() {
    const { start, stop, active, timer_loading, manual, add, manualObj, clearState} = this.props
    return (
      <div>
        { timer_loading ? (
          <div className="loading-btn">
            <img src={loadImg} alt=""/>
          </div>
        ) : (
          (manual)?(
            <div className="add-btn" onClick={ add.bind(null, manualObj, clearState)}>
              <i className="glyphicon glyphicon-ok"></i>
            </div>
          ):(
            active.start ? (
            <div className="stop-btn" onClick={ stop.bind(null, active)}>
              <i className="glyphicon glyphicon-stop"></i>
            </div>
            ) : (
            <div className="start-btn" onClick={ start.bind(null, active)}>
              <i className="glyphicon glyphicon-play"></i>
            </div>
            )
          )
          
        )}
        
      </div>
    );
  }
}

Startbtn.defaultProps ={
  start: {}, 
  stop: {}, 
  active: {},
  timer_loading: false, 
  manual: false, 
  add: ()=>{},
  manualObj:{}
}

export default Startbtn;
